import { render } from "./VipDetail.vue?vue&type=template&id=7a43b82e&scoped=true"
import script from "./VipDetail.vue?vue&type=script&lang=js"
export * from "./VipDetail.vue?vue&type=script&lang=js"

import "./VipDetail.vue?vue&type=style&index=0&id=7a43b82e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a43b82e"]])

export default __exports__